import { CASINO_CATEGORY_PATH_NAMES } from '../data-types/casino/casinoEnums';
import { QUESTION_MARK, SLASH } from '../data-types/constants';

const APP_PATH = '/';
const LOGIN = 'login/';
const JOIN_PATH = '/join/';
const PROFILE = 'profile/';
const HELP = 'help/';
const RESET_PASSWORD = 'reset-password/';
const CASINO = 'casino/';
const CASINO_GAME = 'casino-game/';
const VERIFICATION = 'verification/';
const SPORTS = 'sports/';
const SPORT = 'sport/';
const PROMO = 'promo/';
const DEPOSIT = 'deposit/';
const REFER_A_FRIEND = 'refer-a-friend/';

export const PATHS = {
  CASINO_RETURN_URL: `${APP_PATH}casino-game-closed/`,
  LOCATION_REJECTED: `${APP_PATH}location_rejected/`,
  LOCATION_DENIED: `${APP_PATH}location_denied/`,
  SURPRISE_REDIRECT: `${APP_PATH}surprise*`,
  MAINTENANCE: `${APP_PATH}maintenance/`,
  WRONG_DOMAIN_ACCESSED: `${APP_PATH}domain-unavailable/`,
  PRODUCTS_UNAVAILABLE: `${APP_PATH}products-unavailable/`,
  APP: {
    ROOT: APP_PATH,
    DEEP_LINK: `${APP_PATH}app/:section/`,
    BETSLIP: `${APP_PATH}betslip/`,
    MY_PROMOTIONS: `${APP_PATH}my-promotions/`,
    CASINO: {
      ROOT: `${APP_PATH}${CASINO}`,
      CATEGORY: (casinoCategoryReplacement: string | number) => `${APP_PATH}${CASINO}${casinoCategoryReplacement}/`,
      FILTER: (category: string | number, filter: string | number) => `${APP_PATH}${CASINO}${category}/${filter}/`,
      GAME: `${APP_PATH}${CASINO_GAME}`,
      GAME_ID: (gameId: number | string) => `${APP_PATH}${CASINO_GAME}${gameId}/`,
      GAME_WITH_PARAMS: (gameId: number | string, providerId: number | string = '', name = '') =>
        `${APP_PATH}${CASINO_GAME}${gameId}/?provider=${providerId}&name=${name}`,
      CASINO_LOGIN: `${APP_PATH}casino-login/`,
      CASINO_FIRST: `${APP_PATH}casino-first/`,
    },
    AVIATOR: `${APP_PATH}fly-x/`,
    MY_BETS: `${APP_PATH}mybets/`,
    HELP: {
      ROOT: `${APP_PATH}${HELP}`,
      PROMOTIONS: `${APP_PATH}${HELP}promotions/`,
      FAQ: `${APP_PATH}${HELP}faqs/`,
      CONTROL: `${APP_PATH}${HELP}control/`,
      RESPONSIBLE: `${APP_PATH}${HELP}problem/`,
      UNDERAGE: `${APP_PATH}${HELP}underage/`,
      SUPPORT: `${APP_PATH}${HELP}support/`,
      BLOCKING: `${APP_PATH}${HELP}blocking/`,
    },
    PROFILE: {
      ROOT: `${APP_PATH}${PROFILE}`,
      DEPOSIT: `${APP_PATH}${PROFILE}${DEPOSIT}`,
      NET: `${APP_PATH}${PROFILE}net/`,
      PASSWORD: `${APP_PATH}${PROFILE}password/`,
      DETAILS: `${APP_PATH}${PROFILE}details/`,
      HISTORY: `${APP_PATH}${PROFILE}history/`,
      PROFIT_AND_LOSS_HISTORY: `${APP_PATH}${PROFILE}profit-and-loss/`,
      PREFERENCES: `${APP_PATH}${PROFILE}preferences/`,
      NOTIFICATIONS: `${APP_PATH}${PROFILE}notifications/`,
      MARKETING: `${APP_PATH}${PROFILE}marketing/`,
      CONTROL: `${APP_PATH}${PROFILE}control/`,
      EXCLUSION: `${APP_PATH}${PROFILE}exclusion/`,
      TIMEOUT: `${APP_PATH}${PROFILE}timeout/`,
      BLOCK: `${APP_PATH}${PROFILE}block/`,
      WITHDRAWAL: `${APP_PATH}${PROFILE}withdrawal/`,
      CLOSE: `${APP_PATH}${PROFILE}close/`,
      REFER_A_FRIEND: `${APP_PATH}${PROFILE}${REFER_A_FRIEND}`,
      REFER_A_FRIEND_HOW_IT_WORKS: `${APP_PATH}${PROFILE}${REFER_A_FRIEND}how-it-works/`,
      PROMO_REFER_A_FRIEND: `${APP_PATH}${PROFILE}${PROMO}${REFER_A_FRIEND}`,
      PROMO_REFER_A_FRIEND_HOW_IT_WORKS: `${APP_PATH}${PROFILE}${PROMO}${REFER_A_FRIEND}how-it-works/`,
      VERIFICATION: {
        ROOT: `${APP_PATH}${PROFILE}${VERIFICATION}`,
        DOCUMENTS: `${APP_PATH}${PROFILE}${VERIFICATION}documents/`,
        PROOF_REQUEST_DETAILS: {
          ROOT: `${APP_PATH}${PROFILE}${VERIFICATION}documents/details/`,
          SPECIFIC_PATTERN: `${APP_PATH}${PROFILE}${VERIFICATION}documents/details/:id/`,
          SPECIFIC: (id: number) => `${APP_PATH}${PROFILE}${VERIFICATION}documents/details/${id}/`,
        },
        EMPLOYMENT_DETAILS: {
          ROOT: `${APP_PATH}${PROFILE}${VERIFICATION}employment-details/`,
          QUESTIONS: `${APP_PATH}${PROFILE}${VERIFICATION}employment-details/questions/`,
          THANK_YOU: `${APP_PATH}${PROFILE}${VERIFICATION}employment-details/thank-you/`,
        },
        SAFER_GAMBLING: {
          ROOT: `${APP_PATH}${PROFILE}${VERIFICATION}safer-gambling/questions/`,
          THANK_YOU: `${APP_PATH}${PROFILE}${VERIFICATION}safer-gambling/thank-you/`,
        },
      },
      PROFILE_LOGIN: `${APP_PATH}profile-login/`,
    },
    REFERRAL: {
      ROOT: `${APP_PATH}app/refer/`,
    },
    SPORTS: {
      SPORTS_ROOT: `${APP_PATH}${SPORTS}`,
      DEFAULT: `${APP_PATH}${SPORTS}default/`,

      SPORT_ID: (sportReplacement: string, searchTerm?: string) => {
        const basePath = `${APP_PATH}${SPORTS}${sportReplacement}/`;

        if (searchTerm) {
          return `${basePath}?searchTerm=${searchTerm}`;
        }

        return basePath;
      },

      CATEGORY: (sportReplacement: string, sportSectionReplacement: string, searchTerm?: string) => {
        const basePath = `${APP_PATH}${SPORTS}${sportReplacement}/${sportSectionReplacement}/`;

        if (searchTerm) {
          return `${basePath}?searchTerm=${searchTerm}`;
        }

        return basePath;
      },

      SUBCATEGORY: (sportReplacement: string, sportSectionReplacement: string, sportSubSectionReplacement: string, searchTerm?: string) => {
        const basePath = `${APP_PATH}${SPORTS}${sportReplacement}/${sportSectionReplacement}/${sportSubSectionReplacement}/`;

        if (searchTerm) {
          return `${basePath}?searchTerm=${searchTerm}`;
        }

        return basePath;
      },

      EVENT_ROOT: `${APP_PATH}${SPORT}`,

      EVENT_DETAIL: (sportReplacement: string, eventIdReplacement: string | number) =>
        `${APP_PATH}${SPORT}${sportReplacement}/event/${eventIdReplacement}/`,

      EVENT_DETAIL_MULTI_LIST_EVENTS: (sport: string, eventId: string | number, sportReplacement: string, searchTerm?: string) => {
        const basePath = `${APP_PATH}${SPORT}${sport}/event/${eventId}/?sport=${sportReplacement}`;

        if (searchTerm) {
          return `${basePath}&searchTerm=${searchTerm}`;
        }

        return basePath;
      },

      EVENT_DETAIL_CATEGORY: (
        sport: string,
        eventId: string | number,
        sportReplacement: string,
        sportSectionReplacement: string,
        searchTerm?: string,
      ) => {
        const basePath = `${APP_PATH}${SPORT}${sport}/event/${eventId}/?sport=${sportReplacement}&section=${sportSectionReplacement}`;

        if (searchTerm) {
          return `${basePath}&searchTerm=${searchTerm}`;
        }

        return basePath;
      },

      EVENT_DETAIL_SUBCATEGORY: (
        sport: string,
        eventId: string | number,
        sportReplacement: string,
        sportSectionReplacement: string,
        sportSubSectionReplacement: string,
        searchTerm?: string,
      ) => {
        const basePath = `${APP_PATH}${SPORT}${sport}/event/${eventId}/?sport=${sportReplacement}&section=${sportSectionReplacement}&subsection=${sportSubSectionReplacement}`;

        if (searchTerm) {
          return `${basePath}&searchTerm=${searchTerm}`;
        }

        return basePath;
      },
    },
  },
  LOGIN: {
    ROOT: `${APP_PATH}${LOGIN}`,
    RESET_PASSWORD: {
      ROOT: `${APP_PATH}${LOGIN}${RESET_PASSWORD}`,
      REQUEST: `${APP_PATH}${LOGIN}${RESET_PASSWORD}request/`,
      VERIFY: `${APP_PATH}${LOGIN}${RESET_PASSWORD}verify/`,
      RESET: `${APP_PATH}${LOGIN}${RESET_PASSWORD}reset/`,
      SUCCESS: `${APP_PATH}${LOGIN}${RESET_PASSWORD}success/`,
    },
  },
  SIGNUP: {
    ROOT: JOIN_PATH,
    ZIMPLER_DEPOSIT_CHOICE: `${JOIN_PATH}zimpler-deposit/`,
    STEPS: {
      EMAIL: `${JOIN_PATH}email/`,
      PASSWORD: `${JOIN_PATH}password/`,
      OFFERS_AND_REWARDS: `${JOIN_PATH}offers-and-rewards/`,
      TERMS_AND_CONDITIONS: `${JOIN_PATH}terms-and-conditions/`,
      INFO: `${JOIN_PATH}info/`,
      ADDRESS: `${JOIN_PATH}address/`,
      PHONE: `${JOIN_PATH}phone/`,
      DEPOSIT_LIMIT: `${JOIN_PATH}depositLimit/`,
      DEPOSIT: `${JOIN_PATH}deposit/`,
      UNVERIFIED: `${JOIN_PATH}unverified/`,
      VERIFIED: `${JOIN_PATH}accountVerified/`,
      OPT_IN_REWARDS: `${JOIN_PATH}opt-in-rewards/`,
    },
  },
};

export const DEFAULT_REDIRECTS = {
  SPORTS: PATHS.APP.SPORTS.DEFAULT,
  CASINO: PATHS.APP.CASINO.CATEGORY(CASINO_CATEGORY_PATH_NAMES.FEATURED),
};

const ensureTrailingSlash = (path: string) => (path[path.length - 1] !== SLASH ? path.concat(SLASH) : path);

export const getSearchPathWithTrailingSlash = (url: string) => {
  const splitPathFromSearch = url.split(QUESTION_MARK);

  if (splitPathFromSearch.length > 0) {
    splitPathFromSearch[0] = ensureTrailingSlash(splitPathFromSearch[0]);
  }
  const adjustedUrl = splitPathFromSearch.join(QUESTION_MARK);

  return adjustedUrl;
};

export const PROD_KENYA_DOMAIN = 'betkwiff.ke';
